import { SignalRHubListener } from '@common/websocket/signal-r-hub-listener';
import { environment } from '@/environments/environment';
import { NOTIFIER, Notifier } from '@shared/notifier/types';
import { Inject, Injectable } from '@angular/core';
import { clientToServerCalls } from '@common/const/client-to-server-calls';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { Announcement } from '@/app/platform/platform-data/models/announcement';
import Morphism from 'morphism';
import { DateService } from '@shared/services/date.service';
import { ShowAnnouncementType } from '@/app/platform/platform-data/models/show-announcement-type';

@Injectable({
  providedIn: 'root'
})
export class NotificationsListener extends SignalRHubListener {
  readonly _announcements$ = new BehaviorSubject<Announcement[]>([]);

  constructor(
    @Inject(NOTIFIER)
    notifier: Notifier,
    private readonly dateService: DateService
  ) {
    super(
      `${environment.apiPaths.egituraPlatformApi}/notifications`,
      {
        name: 'platform-notifications',
        incrementalRetryThresholdMS: 60000
      },
      notifier
    );
  }

  announcementByKey$(key: string): Observable<Announcement | undefined> {
    return combineLatest([this._announcements$, this.dateService.date$]).pipe(
      map(([announcements, date]) => {
        const announcement = announcements.find(a => a.key === key);

        if (!announcement) {
          return;
        }

        if (
          announcement.show === ShowAnnouncementType.BetweenDates &&
          !date.isBetween(announcement.showFrom, announcement.showTo)
        ) {
          return undefined;
        }
        return announcement;
      })
    );
  }

  async afterConnected(isReconnect: boolean = false): Promise<void> {
    this.hubConnection.invoke(clientToServerCalls.initializeClientAfterConnectedAsync);

    // afterConnected loopt bij elke (her)verbinding; registerMessageHandler vervangt in plaats van toe te voegen.
    this.registerMessageHandler('announcementsupdate', b => {
      const m = Morphism.map(Announcement, b.announcements as any[]);
      this._announcements$.next(m);
    });

    await super.afterConnected(isReconnect);
  }
}
